(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pishuw-card-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArrows(root) {
      var track = root.querySelector('[data-cg-track]');
      var prev = root.querySelector('[data-cg-prev]');
      var next = root.querySelector('[data-cg-next]');
      if (!track || !prev || !next) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft <= 4;
        next.hidden = track.scrollLeft >= max - 4;
      }
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function init(root) {
      if (root.dataset.cgReady) return;
      root.dataset.cgReady = '1';
      initArrows(root);
      var vids = root.querySelectorAll('video[data-cg-autoplay]');
      if (!vids.length || !('IntersectionObserver' in window)) {
        // No lazy support: just let them play.
        vids.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); }
          else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
    function boot() { document.querySelectorAll('[data-pishuw-cg]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-guarantee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.rftReady) return;
      root.dataset.rftReady = '1';
      root.querySelectorAll('[data-rft-top]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
    }
    function boot() { document.querySelectorAll('[data-pishuw-guarantee]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.phInit) return;
    root.dataset.phInit = '1';
    var track = root.querySelector('[data-ph-track]');
    if (!track) return;
    var real = track.children.length;
    if (real <= 1) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ph-hero__rev-dot'));
    var delay = parseInt(root.dataset.autoplay, 10) || 5000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Clone last -> front and first -> end so the loop is seamless in both directions.
    var lastClone = track.children[real - 1].cloneNode(true);
    var firstClone = track.children[0].cloneNode(true);
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.setAttribute('aria-hidden', 'true');
    track.insertBefore(lastClone, track.firstChild);
    track.appendChild(firstClone);
    // DOM order now: [0]=lastClone, [1..real]=real slides, [real+1]=firstClone

    var current = 0, hovering = false, holding = false, settle = null, timer = null;
    function w() { return track.clientWidth; }
    function setDots() { dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); }); }
    function jump(dom) { var prev = track.style.scrollBehavior; track.style.scrollBehavior = 'auto'; track.scrollLeft = dom * w(); track.style.scrollBehavior = prev; }
    function glide(dom) { track.scrollTo({ left: dom * w(), behavior: reduce ? 'auto' : 'smooth' }); }
    function paused() { return hovering || holding || document.hidden; }

    function advance() {
      if (current >= real - 1) { current = 0; setDots(); glide(real + 1); }
      else { current += 1; setDots(); glide(current + 1); }
    }
    function onSettle() {
      var dom = Math.round(track.scrollLeft / w());
      if (dom === 0) { current = real - 1; setDots(); jump(real); }
      else if (dom === real + 1) { current = 0; setDots(); jump(1); }
      else if (dom - 1 !== current) { current = dom - 1; setDots(); }
    }

    track.addEventListener('scroll', function () { clearTimeout(settle); settle = setTimeout(onSettle, 120); }, { passive: true });
    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    ['pointerdown', 'touchstart'].forEach(function (e) { track.addEventListener(e, function () { holding = true; }, { passive: true }); });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (e) { track.addEventListener(e, function () { holding = false; }, { passive: true }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { current = i; setDots(); glide(i + 1); }); });

    function start() { if (reduce) return; stop(); timer = setInterval(function () { if (!paused()) advance(); }, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    window.addEventListener('resize', function () { jump(current + 1); });

    function place() { jump(current + 1); setDots(); }
    place();
    requestAnimationFrame(place);
    if (document.readyState !== 'complete') window.addEventListener('load', place);
    start();
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-ph-carousel]').forEach(initCarousel); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-mechanism"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.mechReady) return;
      root.dataset.mechReady = '1';
      var hot = root.querySelectorAll('.pishuw-hotspot');
      var pan = root.querySelectorAll('.pishuw-mech__panel');
      var dot = root.querySelectorAll('.pishuw-mech__dots button');
      var fills = root.querySelectorAll('.pishuw-mech__dot-fill');
      var count = pan.length;
      var current = 0;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoOn = root.dataset.mechAuto === '1' && count > 1 && !reduced;
      var durMs = (parseFloat(root.dataset.mechDur) || 4) * 1000;
      var rafId = null, paused = false, progress = 0, lastTs = null;

      function activeFill() { return root.querySelector('.pishuw-mech__dots button.is-active .pishuw-mech__dot-fill'); }
      function stopAuto() { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } }
      function tick(ts) {
        if (lastTs === null) lastTs = ts;
        var dt = ts - lastTs; lastTs = ts;
        if (!paused) {
          progress += dt / durMs;
          if (progress >= 1) { select(current + 1); return; }
          var f = activeFill(); if (f) f.style.width = (progress * 100) + '%';
        }
        rafId = requestAnimationFrame(tick);
      }
      function startAuto() {
        stopAuto();
        if (!autoOn) return;
        progress = 0; lastTs = null;
        var f = activeFill(); if (f) f.style.width = '0%';
        rafId = requestAnimationFrame(tick);
      }

      function select(n) {
        if (count) { n = (n % count + count) % count; }
        current = n;
        hot.forEach(function (h) { h.classList.toggle('is-active', +h.dataset.hot === n); });
        pan.forEach(function (p) { p.classList.toggle('is-active', +p.dataset.panel === n); });
        dot.forEach(function (d) { d.classList.toggle('is-active', +d.dataset.dot === n); });
        fills.forEach(function (f) { f.style.width = ''; });
        startAuto();
      }
      hot.forEach(function (h) { h.addEventListener('click', function () { select(+h.dataset.hot); }); });
      dot.forEach(function (d) { d.addEventListener('click', function () { select(+d.dataset.dot); }); });

      // Pause autoplay while the visitor is hovering/touching the diagram.
      if (autoOn) {
        var diag = root.querySelector('.pishuw-mech__diagram');
        if (diag) {
          diag.addEventListener('mouseenter', function () { paused = true; });
          diag.addEventListener('mouseleave', function () { paused = false; });
        }
        startAuto();
      }

      // Swipe the panels (and image stage) left/right to step through.
      if (count > 1) {
        var x0 = null, y0 = null, locked = false;
        function down(e) { var t = e.touches ? e.touches[0] : e; x0 = t.clientX; y0 = t.clientY; locked = false; paused = true; }
        function move(e) {
          if (x0 === null) return;
          var t = e.touches ? e.touches[0] : e;
          var dx = t.clientX - x0, dy = t.clientY - y0;
          if (!locked && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) { locked = true; }
          if (locked && e.cancelable) e.preventDefault();
        }
        function up(e) {
          if (x0 === null) return;
          var t = e.changedTouches ? e.changedTouches[0] : e;
          var dx = t.clientX - x0, dy = t.clientY - y0;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { select(current + (dx < 0 ? 1 : -1)); }
          x0 = y0 = null; paused = false;
        }
        root.querySelectorAll('.pishuw-mech__panels, .pishuw-mech__stage').forEach(function (zone) {
          zone.addEventListener('touchstart', down, { passive: true });
          zone.addEventListener('touchmove', move, { passive: false });
          zone.addEventListener('touchend', up);
        });
      }
    }
    function boot() { document.querySelectorAll('[data-pishuw-mech]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-problem-around"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.paReady) return;
      root.dataset.paReady = '1';
      var v = root.querySelector('[data-pa-video]');
      if (!v) return;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
      }, { rootMargin: '300px 0px', threshold: 0.1 });
      io.observe(v);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { v.pause(); } });
    }
    function boot() { document.querySelectorAll('[data-pishuw-problem-around]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-problem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.peReady) return;
      root.dataset.peReady = '1';
      var v = root.querySelector('[data-pe-video]');
      if (!v) return;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.25 });
      io.observe(v);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { v.pause(); } });
    }
    function boot() { document.querySelectorAll('[data-pishuw-problem]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STAR_PATH = "M12 0.8 L14.55 8.05 L22.2 8.05 L16.0 12.6 L18.35 20.0 L12 15.4 L5.65 20.0 L8.0 12.6 L1.8 8.05 L9.45 8.05 Z";
    var STAR_X = [1.8, 27.8, 53.8, 79.8, 105.8];
    var TILE_X = [0, 26, 52, 78, 104];
    var STAR_SVG = (function () {
      var rects = TILE_X.map(function (x) { return '<rect x="' + x + '" y="0" width="24" height="24" rx="3" fill="currentColor"/>'; }).join("");
      var stars = STAR_X.map(function (x) { return '<path transform="translate(' + x + ' 2.3) scale(0.8792)" d="' + STAR_PATH + '"/>'; }).join("");
      return '<svg class="dc-review-stars" viewBox="0 0 128 24" role="img" aria-label="5 star rating" xmlns="http://www.w3.org/2000/svg">' + rects + '<g fill="#fff">' + stars + '</g></svg>';
    })();

    var filterCopy = {
      sleep: "Reviews from parents who finally got longer stretches and calmer nights.",
      reflux: "Reviews from parents who were dealing with reflux.",
      gas: "Reviews from parents dealing with wind, tummy pain, and post-feed discomfort.",
      peace: "Reviews from parents who needed the fear and constant checking to ease.",
      "worth-it": "Reviews from parents who felt DreamCradle justified itself quickly.",
      easy: "Reviews from parents who loved how practical it was in real life."
    };

    var reviews = {
      sleep: [
        { badge: "7 to 9 hour stretches", quote: "Quick delivery and quality, and baby is sleeping dramatically better. She went from 2-hour to 7 to 9 hour sleep stretches. 100% recommend.", name: "Jodie M.", detail: "Sleep breakthrough" },
        { badge: "Almost 7 hours", quote: "I'm so proud of this purchase. My wife hates admitting it, but baby slept almost 7 hours straight and 4+ hour stretches are now common. Just try it, you won't regret it.", name: "Vio U.", detail: "Longer stretches now common" },
        { badge: "Falls asleep faster", quote: "Absolute game changer. My 2-month-old fell asleep on it faster than she ever did in my arms. She's content on it awake too.", name: "Emma L.", detail: "Fast settling" },
        { badge: "Saved our sanity", quote: "This has literally saved our sanity. Baby finally sleeps peacefully and looks genuinely comfortable, something we hadn't seen in weeks.", name: "Maya S.", detail: "Calm, comfortable sleep" },
        { badge: "Changed our sleep", quote: "Honestly this bed changed our sleep. We sleep better knowing our baby sleeps better. She's 3 months old and still sleeps so peacefully in it.", name: "Jasmine T.", detail: "Family sleep improvement" },
        { badge: "Absolute godsend", quote: "My grandson had so much trouble sleeping. He's now doing 5 to 7 hours, where before we were lucky to get 3 overnight. An absolute godsend.", name: "Zoe E.", detail: "Grandparent review" },
        { badge: "4 to 5 hours", quote: "Bought one a week ago for my granddaughter. She wasn't sleeping well. Since using this she's sleeping 4 to 5 hours. My daughter is so happy.", name: "Andrea K.", detail: "One-week improvement" },
        { badge: "One-night shift", quote: "My baby went from waking up constantly to sleeping long stretches in one night. No more changing sheets daily, or in the middle of the night.", name: "Ciara B.", detail: "Long stretches fast" }
      ],
      reflux: [
        { badge: "Preemie support", quote: "My baby was born at 29 weeks with reflux. This stopped the terrifying choking episodes I had nightmares about. A god-send, especially for premature babies.", name: "Zara X.", detail: "Severe reflux case" },
        { badge: "Saved us", quote: "Severe reflux. We were taking shifts holding her upright on the couch overnight. The exhaustion was destroying us. After a week she was sleeping 2 to 4 hours on her own. It genuinely saved us.", name: "Sherri K.", detail: "Holding upright to independent sleep" },
        { badge: "Must for reflux", quote: "An absolute must for a newborn. Invaluable for acid reflux management. I tell every new parent I meet about it.", name: "Karen P.", detail: "Strong recommendation" },
        { badge: "Actual dream", quote: "The DreamCradle was an actual dream for my newborn with really bad reflux. Two months of continuous use and the reflux has gone, thankfully. Definitely worth it.", name: "Hafiza R.", detail: "Continuous use result" },
        { badge: "10 out of 10", quote: "Reflux baby? Here's your answer. Our premature boy suffers from awful reflux. This helped so much. Still sleeping in it 4 months on. 10/10.", name: "Craig B.", detail: "Premature baby proof" },
        { badge: "No more holding upright", quote: "My daughter's severe reflux caused nighttime distress. This eliminated the uncomfortable sounds and finally let us sleep without holding her upright post-feed.", name: "Natasha K.", detail: "Nighttime distress eased" },
        { badge: "Helped enormously", quote: "My granddaughter suffered from silent reflux. This cushion helped enormously by keeping her at an incline. She was so much happier.", name: "Cheryl B.", detail: "Silent reflux support" },
        { badge: "Life saver", quote: "A real life saver. Resolved the reflux issues immediately and prevents flat spots. Fast delivery, highly recommend.", name: "Holly B.", detail: "Immediate relief reported" }
      ],
      gas: [
        { badge: "Processes gas better", quote: "Excellent product. I love the angle, it helps my baby process gas so much better. No more arching her back in pain after every feed.", name: "Cara E.", detail: "Post-feed comfort" },
        { badge: "Helps bowel movements", quote: "We had bad colic and I didn't want to give medicine. The way my baby lies on it helps her pass bowel movements easily and relieves the gas from her tummy.", name: "Aleksandra B.", detail: "Colic without medicine" },
        { badge: "One night's difference", quote: "One night's difference was incredible. No colic, no spit up, and it actually helped him poop too. He settles so much faster now.", name: "Naomi J.", detail: "Fast colic relief" },
        { badge: "A lot happier", quote: "My baby was suffering from extreme colic. Sleepless nights were getting the better of us. She's now a lot happier and sleeping much longer.", name: "Jessica H.", detail: "Extreme colic improvement" },
        { badge: "Couldn't imagine routine without it", quote: "So great for a baby with colic. We couldn't imagine our routine without it.", name: "John D.", detail: "Routine staple" },
        { badge: "Relief for her tummy", quote: "My one-month-old is so comfortable. The positional design manages her colic and trapped wind effectively. Finally some relief for her little tummy.", name: "Sarah G.", detail: "Trapped wind comfort" },
        { badge: "Best and most useful purchase", quote: "The best and most useful purchase. My baby's silent reflux and gas issues resolved completely. I've ordered more as gifts.", name: "Clare M.", detail: "Gas and reflux proof" }
      ],
      peace: [
        { badge: "Family peace of mind", quote: "A lifesaver for severe reflux and colic. My grandson is finally comfortable, and it gives the whole family peace of mind about his safety and security at night.", name: "Bianca N.", detail: "Family reassurance" },
        { badge: "Elevated correctly", quote: "It gives me such peace of mind knowing he's elevated correctly, comfy and secure. I finally stopped hovering over the bassinet.", name: "Jessy R.", detail: "Secure and comfy" },
        { badge: "Peaceful nights", quote: "Fantastic product. Me and baby had peaceful nights without any single worry. Highly recommend it.", name: "Magdalena M.", detail: "No-worry nights" },
        { badge: "Velcro strap is brilliant", quote: "The velcro strap is brilliant. It gives me peace of mind knowing she won't roll out of position even if I look away for a second.", name: "Shanelle G.", detail: "Roll-position reassurance" },
        { badge: "Reduces parental stress", quote: "My infant finds it comfortable and it aids digestion, but the anti-rolling belt is what really reduces our parental stress.", name: "Cameron B.", detail: "Stress reduction" },
        { badge: "Best money we've spent", quote: "Best newborn purchase by a mile. Helped with safe co-sleeping and prevented all my rolling concerns. Best money we've spent on the baby.", name: "Alex F.", detail: "Rolling concerns eased" },
        { badge: "Huge relief", quote: "Baby is very happy resting on it and it's easy to take anywhere. A huge relief knowing baby is safely strapped in and comfortable.", name: "Donella H.", detail: "Portable reassurance" },
        { badge: "Felt confident", quote: "The strap on it really helped. We felt confident having him next to us on the sofa if he was having a bad night. Recommend.", name: "Dave L.", detail: "Confidence at night" }
      ],
      "worth-it": [
        { badge: "Worth every penny", quote: "I wish I found this sooner. My baby finally sleeps without being held. Worth every penny. I don't know how we survived without it.", name: "Kayla R.", detail: "Wish I found it sooner" },
        { badge: "It bloody worked", quote: "I was convinced this must be fake advertising. I'd already spent so much on sleep stuff, one more wouldn't hurt. Guess what? It BLOODY WORKED.", name: "Giorgiana R.", detail: "Skeptic converted" },
        { badge: "Great value", quote: "Great for a baby with reflux. I wish I'd had it from day one. Delivery was fast and it's honestly great value for money.", name: "Olivia G.", detail: "Good value" },
        { badge: "Great investment", quote: "Had the exact same nightmare with my boy. Got one, his reflux disappeared. It's a great investment, well worth every cent.", name: "Lyric W.", detail: "Investment justified" },
        { badge: "Recommended to friends", quote: "It helped my 2 grandsons sleep so well. My daughters said it was worth every penny. They've recommended Pishuw to all their friends.", name: "Rhi W.", detail: "Word-of-mouth proof" },
        { badge: "Uses it every night", quote: "I saw this on an ad and was surprised how good it is. Was skeptical at first, now my daughter uses it every single night.", name: "Liam P.", detail: "Ad skeptic turned buyer" },
        { badge: "Definitely yes", quote: "My baby feels very comfortable and settled. For anyone thinking of buying and wondering if it's worth it, definitely yes.", name: "Imeda T.", detail: "Worth-it endorsement" },
        { badge: "100% worth it", quote: "As a dad of a 5-month-old, this is 100% worth it. Gives us so much peace of mind. If it helped us, it'll help you.", name: "David G.", detail: "Dad review" }
      ],
      easy: [
        { badge: "All you need", quote: "Best thing I've done. So easy to manoeuvre. If I had another baby I wouldn't even buy a Moses basket, I'd get this instead. It's all you need till 6 months.", name: "Melissa A.", detail: "Simple setup" },
        { badge: "Portability between rooms", quote: "Improved sleep for babies and parents. Plus the portability between rooms is incredible, bedroom, living room, even travel.", name: "Georgios P.", detail: "Room-to-room portability" },
        { badge: "Goes everywhere", quote: "We have one and it goes EVERYWHERE, pram, crib, Moses basket. The most versatile baby item we own.", name: "McKenzie L.", detail: "Versatile use" },
        { badge: "Zero fuss", quote: "It's so great. I put it in the bassinet and just move it to the pram every time we go for a walk. Zero fuss.", name: "Melinda S.", detail: "Walk-ready" },
        { badge: "Travel-friendly", quote: "Made our baby feel secure and reduced his reflux in bed. The velcro straps make it a perfect portable mini-bed for flying and holidays.", name: "Bonnie K.", detail: "Travel use" },
        { badge: "Portable and adjustable", quote: "Quality product, genuinely portable, adjustable, and very well-made. Exactly what a sleep-deprived parent needs.", name: "Kerry C.", detail: "Portable and well-made" },
        { badge: "Zero complaints", quote: "Adjustable, portable, comfortable. Three words, zero complaints.", name: "Mark V.", detail: "Simple verdict" },
        { badge: "Gave me my arms back", quote: "Finally a bit of time hands-free. With silent reflux it was impossible to put her down. This gave me my arms back.", name: "Linda L.", detail: "Hands-free relief" }
      ]
    };

    function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

    function cardMarkup(review, starsHtml) {
      return '<article class="dc-review-card">'
        + '<div class="dc-review-card__top">'
        + starsHtml
        + '<div class="dc-review-card__badge">' + esc(review.badge) + '</div>'
        + '</div>'
        + '<p class="dc-review-card__quote">"' + esc(review.quote) + '"</p>'
        + '<div class="dc-review-card__meta"><strong>' + esc(review.name) + '</strong><span>' + esc(review.detail) + '</span></div>'
        + '</article>';
    }

    function init(section) {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = "1";
      var starsHtml = section.dataset.starsImg === "1"
        ? '<span class="dc-review-stars dc-review-stars--img" role="img" aria-label="5 star rating"></span>'
        : STAR_SVG;
      var filterButtons = Array.prototype.slice.call(section.querySelectorAll(".dc-review-filter"));
      var track = section.querySelector(".dc-review-track");
      var viewport = section.querySelector(".dc-review-viewport");
      var status = section.querySelector(".dc-review-status");
      var toolbarSummary = section.querySelector(".dc-review-toolbar__summary");
      var prevButton = section.querySelector(".dc-review-nav--prev");
      var nextButton = section.querySelector(".dc-review-nav--next");
      var progressFill = section.querySelector(".dc-review-progress__fill");
      if (!track || !viewport) return;

      function renderReviews(filter, immediate) {
        var items = reviews[filter] || reviews.sleep;
        filterButtons.forEach(function (button) {
          var isActive = button.dataset.filter === filter;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-selected", String(isActive));
        });
        var commitRender = function () {
          track.innerHTML = items.map(function (r) { return cardMarkup(r, starsHtml); }).join("");
          viewport.scrollTo({ left: 0, behavior: "auto" });
          if (status) status.textContent = filterCopy[filter] || filterCopy.sleep;
          requestAnimationFrame(function () {
            track.classList.remove("is-switching");
            if (status) status.classList.remove("is-switching");
            updateNavState();
          });
        };
        if (immediate) { commitRender(); return; }
        track.classList.add("is-switching");
        if (status) status.classList.add("is-switching");
        window.setTimeout(commitRender, 140);
      }

      function scrollAmount() { return Math.max(viewport.clientWidth * 0.86, 320); }

      function updateNavState() {
        var maxScroll = viewport.scrollWidth - viewport.clientWidth - 4;
        var currentScroll = Math.max(viewport.scrollLeft, 0);
        var progress = maxScroll <= 0 ? 1 : Math.min(currentScroll / maxScroll, 1);
        if (progressFill) { progressFill.style.width = (Math.max(progress * 100, maxScroll <= 0 ? 100 : 18)) + "%"; }
        if (window.innerWidth <= 1024) return;
        if (prevButton) prevButton.disabled = currentScroll <= 4;
        if (nextButton) nextButton.disabled = currentScroll >= maxScroll;
      }

      filterButtons.forEach(function (button) {
        button.addEventListener("click", function () { renderReviews(button.dataset.filter || "sleep"); });
      });
      if (prevButton) prevButton.addEventListener("click", function () { viewport.scrollBy({ left: -scrollAmount(), behavior: "smooth" }); });
      if (nextButton) nextButton.addEventListener("click", function () { viewport.scrollBy({ left: scrollAmount(), behavior: "smooth" }); });
      viewport.addEventListener("scroll", updateNavState, { passive: true });
      window.addEventListener("resize", updateNavState);

      renderReviews("sleep", true);
    }

    function boot() { document.querySelectorAll("[data-pishuw-reviews]").forEach(init); }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
    document.addEventListener("shopify:section:load", boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.gstReady) return;
      root.dataset.gstReady = '1';
      var v = root.querySelector('[data-gst-video]');
      if (!v) return;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 });
      io.observe(v);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { v.pause(); } });
    }
    function boot() { document.querySelectorAll('[data-pishuw-stats]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pishuw-versatility"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.versReady) return;
      root.dataset.versReady = '1';
      var track = root.querySelector('[data-vers-track]');
      var prev = root.querySelector('[data-vers-prev]');
      var next = root.querySelector('[data-vers-next]');
      if (!track || !prev || !next) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft <= 4;
        next.hidden = track.scrollLeft >= max - 4;
      }
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function boot() { document.querySelectorAll('[data-pishuw-vers]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
